import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-current" }, "Training", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " The StreetsPDX site has several tools to help users navigate the various policies and corresponding design standards that influence space in the right-of-way as part of private development and with city led capital projects. This page contains resources for navigating and successfully utilizing these tools. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("main", { class: "mt-4 mb-8 grid grid-cols-1 gap-4" }, [
  /*#__PURE__*/_createElementVNode("section", { class: "grid grid-cols-1 lg:grid-cols-2 px-4 lg:pl-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "prose" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Video one – Overview of StreetsPDX"),
      /*#__PURE__*/_createElementVNode("p", null, " This video provides an overview of the StreetsPDX website and tools. ")
    ]),
    /*#__PURE__*/_createElementVNode("iframe", {
      class: "w-full h-96",
      src: "https://www.youtube.com/embed/KnqxCor3jv0",
      title: "YouTube video player",
      frameborder: "0",
      allow: "autoplay; fullscreen; picture-in-picture",
      allowfullscreen: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("section", { class: "grid grid-cols-1 lg:grid-cols-2 px-4 lg:pl-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "prose" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Video two – Development Improvements"),
      /*#__PURE__*/_createElementVNode("p", null, " The second video describes StreetsPDX tools for understanding development related public improvements in the right-of-way. ")
    ]),
    /*#__PURE__*/_createElementVNode("iframe", {
      class: "w-full h-96",
      src: "https://www.youtube.com/embed/DVv1EoJgAs8",
      title: "YouTube video player",
      frameborder: "0",
      allow: "autoplay; fullscreen; picture-in-picture",
      allowfullscreen: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("section", { class: "grid grid-cols-1 lg:grid-cols-2 px-4 lg:pl-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "prose" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Video three – City Projects"),
      /*#__PURE__*/_createElementVNode("p", null, " The last video describes the decision-making process and tools that support the evaluation of tradeoffs as part of city projects. ")
    ]),
    /*#__PURE__*/_createElementVNode("iframe", {
      class: "w-full h-96",
      src: "https://www.youtube.com/embed/OO5MVnT9y9g",
      title: "YouTube video player",
      frameborder: "0",
      allow: "autoplay; fullscreen; picture-in-picture",
      allowfullscreen: ""
    })
  ])
], -1)

import Box from '@/elements/box/Box';

export default /*#__PURE__*/_defineComponent({
  __name: 'Training',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", null, [
    _createVNode(_unref(Box), {
      as: "header",
      color: "gray",
      variant: "light",
      class: "grid grid-cols-1 lg:grid-cols-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Box), {
          as: "section",
          class: "prose prose-lg px-4 lg:pl-12 py-12"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_3
  ]))
}
}

})